import { useState, useEffect } from "react";

const STORAGE_KEY = "campaignsViewMode";

const useViewMode = (defaultMode = "grid") => {
  const [viewMode, setViewMode] = useState(() => {
    try {
      return localStorage.getItem(STORAGE_KEY) || defaultMode;
    } catch (e) {
      return defaultMode;
    }
  });

  useEffect(() => {
    try {
      localStorage.setItem(STORAGE_KEY, viewMode);
    } catch (e) {}
  }, [viewMode]);

  return [viewMode, setViewMode];
};

export default useViewMode;
